import { OrganizationReportAccountCountEntity } from '../entities';
import { authResource } from './Auth';
import { getUrlBase } from '@data-client/rest';
const path = '/organizations/:organizationId/reports/accounts/count/:countId?';
export const OrganizationReportAccountCountResource = authResource({
    path,
    searchParams: {},
    schema: OrganizationReportAccountCountEntity
}).extend((BaseResource) => ({
    get: BaseResource.getList.extend({
        schema: OrganizationReportAccountCountEntity,
        url(params) {
            const base = getUrlBase(path)(params);
            const queryParams = params.reportType
                .map((type) => `reportType=${encodeURIComponent(type)}`)
                .join('&');
            return `${this.urlPrefix}${base}?${queryParams}`;
        }
    })
}));
